// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"6c8a7e50","335":"34fedf55","454":"66024044","666":"01407f0a","935":"ca58e456"}[chunkId] + ".chunk.js";
};